
import React, { useContext, useEffect, useState } from 'react'
import { AuthContext } from '../contexts/AuthContext'
import { useNavigate } from 'react-router-dom';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import HomeIcon from '@mui/icons-material/Home';
import { IconButton, Grid } from '@mui/material';

export default function History() {
    const { getHistoryOfUser } = useContext(AuthContext);
    const [meetings, setMeetings] = useState([]);
    const routeTo = useNavigate();

    useEffect(() => {
        const fetchHistory = async () => {
            try {
                const history = await getHistoryOfUser();
                setMeetings(history);
            } catch {
                // TODO: Implement Snackbar for errors
            }
        }
        fetchHistory();
    }, [])

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0")
        const year = date.getFullYear();
        return `${day}/${month}/${year}`
    }

    return (
        <Box sx={{ p: { xs: 2, sm: 4 }, minHeight: '100vh', backgroundColor: '#f5f5f5' }}>
            
            {/* Home Button */}
            <Box sx={{ mb: 3 }}>
                <IconButton onClick={() => routeTo("/home")} sx={{ fontSize: { xs: 20, sm: 28 } }}>
                    <HomeIcon sx={{ fontSize: { xs: 25, sm: 35 } }} />
                </IconButton>
            </Box>

            {/* Meetings Grid */}
            <Grid container spacing={2}>
                {meetings.length > 0 ? meetings.map((meeting, i) => (
                    <Grid item xs={12} sm={6} md={4} key={i}>
                        <Card variant="outlined" sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', p: 2 }}>
                            <CardContent>
                                <Typography sx={{ fontSize: { xs: 12, sm: 14 }, fontWeight: 500 }} color="text.secondary" gutterBottom>
                                    Code: {meeting.meetingCode}
                                </Typography>
                                <Typography sx={{ mb: 1.5, fontSize: { xs: 12, sm: 14 } }} color="text.secondary">
                                    Date: {formatDate(meeting.date)}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                )) : (
                    <Grid item xs={12}>
                        <Typography sx={{ textAlign: 'center', mt: 4 }} variant="body1" color="text.secondary">
                            No meetings found.
                        </Typography>
                    </Grid>
                )}
            </Grid>
        </Box>
    )
}

